module.exports = __webpack_public_path__ + "static/media/SynthSample.ae231a4f.mp3";